import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the table view for wallets.
 * @extends JetView
 */
export default class tableWalletsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader component
                    cols: [
                        {
                            view: 'datatable', // DataTable view for displaying wallet data
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            height: screen.width < 820 ? 400 : 0, // Set height based on screen width
                            columns: [
                                {
                                    id: 'Action', // Column ID for actions
                                    header: '', // Column header
                                    width: 70, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Acción'), // Tooltip text for the column
                                    template: function (obj) {
                                        // Template function for rendering action icons
                                        if (obj.State == 'I') {
                                            return "<span class='webix_icon wxi-close approve'></span>"; // Icon for inactive state
                                        } else {
                                            if (obj.State == 'A') {
                                                return "<span class='webix_icon wxi-close torefuse'></span>"; // Icon for active state
                                            } else {
                                                return ''; // No icon for other states
                                            }
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID for wallet ID
                                    header: _('ID'), // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Name', // Column ID for wallet name
                                    header: _('Nombre'), // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // Column ID for wallet state
                                    header: _('Estado'), // Column header
                                    editor: 'combo', // Editor type for state column
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') }, // Active state option
                                        { id: 'I', value: _('Inactivado') }, // Inactive state option
                                    ],
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handlers for click actions
                                approve: function (euv, id) {
                                    // Handler for approve action
                                    var vvthis = this; // Reference to the current instance
                                    webix.confirm({
                                        // Confirmation dialog for activating wallet
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Activar Billetera?'),
                                        ok: _('Activar Billetera'),
                                        cancel: _('Salir'),
                                        callback: function (action) {
                                            // Callback for confirmation action
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the clicked item
                                                webix
                                                    .ajax() // AJAX request to activate wallet
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Wallets/ActivateWallet', // API endpoint
                                                        '{"Id":' + item.Id + ', "Partner":' + id_partner + '}', // Request payload
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                // Error handler
                                                                webix.message('Error! '); // Show error message
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                // Success handler
                                                                var resp = JSON.parse(text); // Parse response
                                                                if (!resp.HasError) {
                                                                    // Check for errors in response
                                                                    item.State = 'A'; // Update item state to active
                                                                    webix.message(_('Billetera Activada')); // Show success message
                                                                    vthis.$$('datatable').clearAll(); // Clear datatable
                                                                    vthis.$$('datatable').load(url); // Reload datatable data
                                                                } else {
                                                                    webix.alert({
                                                                        // Show error alert
                                                                        type: 'alert-error',
                                                                        title: 'Error',
                                                                        text: _('Error! '),
                                                                    });
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                                torefuse: function (euv, id) {
                                    // Handler for refuse action
                                    var vvthis = this; // Reference to the current instance
                                    webix.confirm({
                                        // Confirmation dialog for inactivating wallet
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Inactivar Billetera?'),
                                        ok: _('Inactivar Billetera'),
                                        cancel: _('Salir'),
                                        callback: function (action) {
                                            // Callback for confirmation action
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the clicked item
                                                webix
                                                    .ajax() // AJAX request to inactivate wallet
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Wallets/InactivateWallet', // API endpoint
                                                        '{"Id":' + item.Id + ', "Partner":' + id_partner + '}', // Request payload
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                // Error handler
                                                                webix.message('Error! '); // Show error message
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                // Success handler
                                                                var resp = JSON.parse(text); // Parse response
                                                                if (!resp.HasError) {
                                                                    // Check for errors in response
                                                                    item.State = 'I'; // Update item state to inactive
                                                                    webix.message(_('Billetera Inactivada')); // Show success message
                                                                    vthis.$$('datatable').clearAll(); // Clear datatable
                                                                    vthis.$$('datatable').load(url); // Reload datatable data
                                                                } else {
                                                                    webix.alert({
                                                                        // Show error alert
                                                                        type: 'alert-error',
                                                                        title: 'Error',
                                                                        text: _('Error! '),
                                                                    });
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                            },
                            ready: function () {
                                // Event handler for when the datatable is ready
                                if (!this.count()) {
                                    // Check if there are no items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        // Show overlay message
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Set load ahead parameter
                            datafetch: devConfig.getDefaultDataFetch(), // Set data fetch parameter
                            pager: 'pagerA', // Set pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        grid = $$('datatable'); // Reference to the datatable instance
        const _ = this.app.getService('locale')._; // Localization service
        var url = devConfig.geturlApi() + 'es/Wallets/GetWallets?Partner=' + id_partner + '&'; // API URL for fetching wallets
        var filter = ''; // Initialize filter string

        this.on(this.app, 'wallets:filter', (filterData) => {
            // Event listener for filtering wallets
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object and non-empty values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add filter to string
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date filter
                                var date = object[i][1].replace(' 00:00:00', ''); // Clean date string
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to filter
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to filter
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format dateFrom
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format dateTo
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Add partner ID to filter
            grid.clearAll(); // Clear datatable
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data into datatable
            filter = string1; // Update filter variable
        });

        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for after sorting
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data into datatable
        });

        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event handler for item click
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        this.on(this.app, 'player:select', (Id) => {
            // Event listener for player selection
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id); // Load data filtered by player ID
        });
    }
}

// FILE DOCUMENTED
